const GSI_SCRIPT_SRC = 'https://accounts.google.com/gsi/client?hl=en';

let gsiScriptPromise: Promise<void> | null = null;
let gsiInitialized = false;

type GoogleCredentialCallback = (credential: string) => void;

export function loadGoogleGsiScript(): Promise<void> {
  if (gsiScriptPromise) {
    return gsiScriptPromise;
  }

  gsiScriptPromise = new Promise((resolve, reject) => {
    const google = (window as any).google;
    if (google?.accounts?.id) {
      resolve();
      return;
    }

    const existingScript = document.querySelector<HTMLScriptElement>(`script[src="${GSI_SCRIPT_SRC}"]`);
    if (existingScript) {
      existingScript.addEventListener('load', () => resolve(), { once: true });
      existingScript.addEventListener('error', () => reject(new Error('Could not load Google login')), { once: true });
      return;
    }

    const script = document.createElement('script');
    script.src = GSI_SCRIPT_SRC;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Could not load Google login'));
    document.head.appendChild(script);
  });

  return gsiScriptPromise;
}

export function ensureGoogleInitialized(clientId: string, onCredential: GoogleCredentialCallback): boolean {
  const google = (window as any).google;
  if (!google?.accounts?.id) {
    return false;
  }

  if (!gsiInitialized) {
    google.accounts.id.initialize({
      client_id: clientId,
      callback: (response: { credential?: string }) => {
        if (response.credential) {
          onCredential(response.credential);
        }
      },
    });
    gsiInitialized = true;
  }

  return true;
}

export function renderGoogleButton(
  container: HTMLElement,
  options: {
    width?: number;
    onCredential: GoogleCredentialCallback;
    clientId: string;
  },
): void {
  const google = (window as any).google;
  if (!google?.accounts?.id) {
    return;
  }

  ensureGoogleInitialized(options.clientId, options.onCredential);

  const width = Math.max(options.width ?? container.offsetWidth, 320);
  container.innerHTML = '';
  google.accounts.id.renderButton(container, {
    theme: 'outline',
    size: 'large',
    text: 'continue_with',
    shape: 'pill',
    logo_alignment: 'left',
    width,
    locale: 'en',
  });
}
